import { Component, OnInit } from '@angular/core';
import { LoginService } from '../../service/login.service';
import { ResendLink } from '../../models/resendlink';
import { Router } from '@angular/router';

@Component({
  selector: 'app-resend-verificationlink',
  templateUrl: './resend-verificationlink.component.html',
  styleUrls: ['./resend-verificationlink.component.css']
})
export class ResendVerificationlinkComponent implements OnInit {

  public resendlink = new ResendLink("");
  public validationerror: string;
  public loading: boolean;
  public focus: boolean;

  constructor(
    private loginService: LoginService,
    private router: Router) { }

  ngOnInit() {
  }

  public ResendLink() {
    this.loading = true;
    this.loginService.ResendConfirmationLink(this.resendlink)
      .subscribe(
        data => {
          this.loading = false;
          this.router.navigate(["/Thankyou"], { queryParams: { status: 'verificationlinkResent' } });
        },
        error => {
          console.log(error);
          if (error.status == 400) {
            if (JSON.parse(error._body)["Email"][0] == "Invalid Email") {
              this.loading = false;
              this.validationerror = "Email must be a valid email address";
              setTimeout(() => {
                this.validationerror = "";
              }, 5000);
            }
          }
          else if (error.status == 401) {
            this.loading = false;
            this.validationerror = JSON.parse(error._body).message;
            setTimeout(() => {
              this.validationerror = "";
            }, 8000);
          }
          else if (error.status == 404) {
            this.loading = false;
            this.validationerror = "Entered email acccount does not exist.";
            setTimeout(() => {
              this.validationerror = "";
            }, 5000);
          }
          else if (error.status == 403) {
            this.loading = false;
            this.validationerror = "Your email is not verified. We have sent you a verification email. Please click on the link there to verify your email address.";
            setTimeout(() => {
              this.validationerror = "";
            }, 12000);
          }
          else if (error.status == 500) {
            this.loading = false;
            this.validationerror = "Internal Server Error";
            setTimeout(() => {
              this.validationerror = "";
            }, 5000);
          }
        });
  }
}
